import { defaultMarketResearchState } from "@relode/core";
import produce from "immer";

import names, { JobActionTypes } from "./jobActionTypes";
import { JobState } from "./jobState";

export const jobReducer = (state: JobState, action: JobActionTypes) =>
    produce(state, draft => {
        switch (action.type) {
            case names.LOAD_JOB: {
                draft.ui.isJobLoading = true;
                draft.data.marketResearchAvailable = false;
                draft.data.marketResearch = defaultMarketResearchState;
                break;
            }

            case names.LOAD_JOB_SUCCESS: {
                draft.data.currentJobId = action.payload.jobId;
                draft.data.job = action.payload.job;
                draft.data.marketResearchAvailable =
                    action.payload.job.details.showMarketResearchData;
                draft.ui.isJobLoading = false;
                draft.ui.error = undefined;
                break;
            }

            case names.LOAD_JOB_FAILURE: {
                draft.ui.isJobLoading = false;
                draft.ui.error = {
                    type: "loadJobFailure",
                    apiError: action.payload.apiError,
                };
                break;
            }

            case names.LOAD_JOB_SHARE: {
                draft.ui.isJobLoading = true;
                break;
            }

            case names.LOAD_JOB_SHARE_SUCCESS: {
                draft.data.currentJobId = action.payload.jobId;
                draft.data.shareDetails = action.payload.jobShareDetails;
                draft.ui.isJobLoading = false;
                draft.ui.error = undefined;

                break;
            }

            case names.LOAD_JOB_SHARE_FAILURE: {
                draft.ui.isJobLoading = false;
                draft.ui.error = {
                    type: "loading",
                    apiError: action.payload.apiError,
                };
                break;
            }

            case names.LOAD_TEAM_MEMBER_SUGGESTIONS_SUCCESS: {
                draft.data.shareSuggestions = action.payload.suggestions;
                draft.ui.error = undefined;

                break;
            }

            case names.LOAD_TEAM_MEMBER_SUGGESTIONS_FAILURE: {
                draft.ui.error = {
                    type: "suggestionsLoading",
                    apiError: action.payload.apiError,
                };
                break;
            }

            case names.MANAGE_TEAM_MEMBER: {
                draft.ui.isJobLoading = true;
                break;
            }

            case names.MANAGE_TEAM_MEMBER_SUCCESS: {
                draft.ui.isJobLoading = false;
                break;
            }

            case names.MANAGE_TEAM_MEMBER_FAILURE: {
                draft.ui.error = {
                    type: "addNewTeamMember",
                    apiError: action.payload.apiError,
                };
                draft.ui.isJobLoading = false;
                break;
            }

            case names.UPDATE_JOB_STATUS: {
                draft.ui.isJobLoading = true;
                break;
            }

            case names.UPDATE_JOB_STATUS_SUCCESS: {
                draft.ui.isJobLoading = false;
                draft.data.job = action.payload.jobDetails;
                draft.ui.error = undefined;
                break;
            }

            case names.UPDATE_JOB_STATUS_FAILURE: {
                draft.ui.isJobLoading = false;
                draft.ui.error = {
                    type: "statusChange",
                    apiError: action.payload.apiError,
                };
                break;
            }

            case names.SET_SELECTED_TAB: {
                draft.ui.selectedTab = action.payload.tab;
                break;
            }

            case names.CLEAR_ERROR: {
                draft.ui.error = undefined;
                break;
            }

            case names.MARKET_RESEARCH_COMPENSATION: {
                draft.data.marketResearch.compensation = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_COMPENSATION_SUCCESS: {
                draft.data.marketResearch.compensation = {
                    isBusy: false,
                    error: undefined,
                    data: action.payload.data,
                };
                break;
            }

            case names.MARKET_RESEARCH_COMPENSATION_FAILURE: {
                draft.data.marketResearch.compensation = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUPPLY_DEMAND: {
                draft.data.marketResearch.supplyDemand = {
                    isBusy: true,
                    data: undefined,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS: {
                draft.data.marketResearch.supplyDemand = {
                    data: action.payload.data,
                    isBusy: false,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE: {
                draft.data.marketResearch.supplyDemand= {
                    error: action.payload.error,
                    isBusy: false,
                    data: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_DIVERSITY: {
                draft.data.marketResearch.diversity = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_DIVERSITY_SUCCESS: {
                draft.data.marketResearch.diversity = {
                    isBusy: false,
                    data: action.payload.data,
                };
                break;
            }

            case names.MARKET_RESEARCH_DIVERSITY_FAILURE: {
                draft.data.marketResearch.diversity = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_SHARE: {
                draft.data.marketResearch.share = {
                    isBusy: true,
                };
                break;
            }

            case names.MARKET_RESEARCH_SHARE_SUCCESS: {
                draft.data.marketResearch.share = {
                    isBusy: false,
                    data: action.payload.data,
                };
                break;
            }

            case names.MARKET_RESEARCH_SHARE_FAILURE: {
                draft.data.marketResearch.share = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUMMARY: {
                draft.data.marketResearch.summary = {
                    isBusy: true,
                    data: undefined,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUMMARY_SUCCESS: {
                draft.data.marketResearch.summary = {
                    isBusy: false,
                    data: action.payload.summary,
                    error: undefined,
                };
                break;
            }

            case names.MARKET_RESEARCH_SUMMARY_FAILURE: {
                draft.data.marketResearch.summary = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.LOAD_JOB_CANDIDATES_FUNNEL: {
                draft.ui.isJobCandidatesFunnelLoading = true;
                draft.ui.jobCandidatesFunnelError = undefined;
                draft.data.job.jobCandidatesFunnel = undefined;
                break;
            }

            case names.LOAD_JOB_CANDIDATES_FUNNEL_SUCCESS: {
                draft.ui.isJobCandidatesFunnelLoading = false;
                draft.data.job.jobCandidatesFunnel =
                    action.payload.jobCandidatesFunnel;
                break;
            }

            case names.LOAD_JOB_CANDIDATES_FUNNEL_FAILURE: {
                draft.ui.isJobCandidatesFunnelLoading = false;
                draft.ui.jobCandidatesFunnelError = action.payload.apiError;
                break;
            }

            case names.LOAD_JOB_ENGAGEMENT_FUNNEL: {
                draft.ui.isJobEngagementFunnelLoading = true;
                draft.ui.jobEngagementFunnelError = undefined;
                draft.data.job.jobEngagementFunnel = undefined;
                break;
            }

            case names.LOAD_JOB_ENGAGEMENT_FUNNEL_SUCCESS: {
                draft.ui.isJobEngagementFunnelLoading = false;
                draft.data.job.jobEngagementFunnel =
                    action.payload.jobEngagementFunnel;
                break;
            }

            case names.LOAD_JOB_ENGAGEMENT_FUNNEL_FAILURE: {
                draft.ui.isJobEngagementFunnelLoading = false;
                draft.ui.jobEngagementFunnelError = action.payload.apiError;
                break;
            }

            case names.LOAD_JOB_STATS: {
                draft.ui.isJobStatsLoading = true;
                draft.ui.jobStatsError = undefined;
                draft.data.job.jobStats = undefined;
                break;
            }

            case names.LOAD_JOB_STATS_SUCCESS: {
                draft.ui.isJobStatsLoading = false;
                draft.data.job.jobStats = action.payload.jobStats;
                break;
            }

            case names.LOAD_JOB_STATS_FAILURE: {
                draft.ui.isJobStatsLoading = false;
                draft.ui.jobStatsError = action.payload.apiError;
                break;
            }
        }
    });
